/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import { Helmet } from "react-helmet-async";
import { makeStyles } from "@material-ui/core/styles";
import InshaHeader from "views/InshaBanglesPage/Section/InshaHeader";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import InshaFooter from "./InshaFooter";
import InshaHeaderLink from "./InshaHeaderLink";
// import SectionDescription from "views/AboutUsPage/Sections/SectionDescription.js";
import CareerDescription from "views/InshaBanglesPage/Section/CareerDescription";
// import SectionTeam from "views/AboutUsPage/Sections/SectionTeam.js";
// import SectionOffice from "views/AboutUsPage/Sections/SectionOffice.js";

import aboutUsStyle from "assets/jss/material-kit-pro-react/views/aboutUsStyle.js";
import aboutUsStyl from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";

const useStyles = makeStyles(aboutUsStyle);
const useStyle = makeStyles(aboutUsStyl);

export default function CareerField() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();
  const classe = useStyle();

  const currentUrl = "https://inshabangles.com/careers";
  const seoTitle = "Careers at INSHA BANGLES | Jobs in Jewellery Industry";
  const seoDescription =
    "Explore career opportunities at INSHA BANGLES. Join our jewellery manufacturing team in India and grow your career in design, production, sales, and operations.";
  const seoKeywords =
    "INSHA BANGLES careers, jewellery jobs India, bangles manufacturer jobs, imitation jewellery careers, production jobs, sales jobs, careers in jewellery industry";
  const ogImage =
    "https://inshabangles.com/imgstore/original_logo/IndianBanglesImgLogo.png";

  const careerSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Careers at INSHA BANGLES",
    url: currentUrl,
    description: seoDescription,
    publisher: {
      "@type": "Organization",
      name: "INSHA BANGLES",
      logo: {
        "@type": "ImageObject",
        url: ogImage,
      },
    },
  };

  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={currentUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="INSHA BANGLES" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={ogImage} />

        <script type="application/ld+json">
          {JSON.stringify(careerSchema)}
        </script>
      </Helmet>
      <InshaHeader
        brand="Home"
        links={<InshaHeaderLink dropdownHoverColor="dark" />}
        fixed
        color="dark"
        // color="transparent"
        // changeColorOnScroll={{
        //   height: 300,
        //   color: "dark",
        // }}
      />
      <Parallax
        image={require("assets/img/Carrers.jpg").default}
        // filter="dark"
        small
        style={
          window.innerWidth <= 600
            ? {
                height: "260px",
                minHeight: "260px",
                backgroundSize: "cover",
                backgroundPosition: "center center",
              }
            : {}
        }
      >
        <div className={classe.container}>
          <GridContainer>
            <GridItem
              md={10}
              sm={10}
              className={classNames(
                classe.mlAuto,
                classe.mrAuto,
                // classe.textCenter,
              )}
            >
              <h1
                style={{
                  color: "#000",
                  fontFamily: "Tahoma",
                  fontWeight: "bold",
                }}
              >
                Career
              </h1>
              {/* <h4 style={{ color: "#000" }}>
                Explore your career Opportunities
              </h4> */}
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <CareerDescription />
          {/* <SectionTeam /> */}
          {/* <SectionOffice /> */}
          <br />
        </div>
      </div>
      <br />
      <br />
      <InshaFooter />
    </div>
  );
}
